module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/model_black-b81b3c9c86ab60c6baed07eb17bd1ad7.png";